import React from "react";
import LabelValue from "../../shared/custom/labelValue/LabelValue";
import { isArray } from "../../shared/utils/arrayUtils";
import { useLanguageForShared } from "../../shared/utils/languages/useLanguageForShared";
import TemplateConcentratorPrescriptionRead from "./TemplateConcentratorPrescriptionRead";
import { TemplateConcentratorPulsedFlowRead } from "./TemplateConcentratorPulsedFlowRead";
import { oxygenPlusConcentratorType } from "../oxygenPlusConcentratorData";
import { VoxiSudFooterRead } from "./VoxiSudFooterRead";

export function TemplateOxygenPlusConcentratorVoxiSudRead({ data }: any) {
  const { t } = useLanguageForShared();

  const selectedType = data?.oxygenPlusConcentratorType;

  const tipologiaLabel = (() => {
    switch (selectedType) {
      case oxygenPlusConcentratorType.oxygen_portable:
        return t("oxygenPlusConcentrator.type.oxygen_portable");
      case oxygenPlusConcentratorType.oxygen_transportable:
        return t("oxygenPlusConcentrator.type.oxygen_transportable");
      default:
        return t("oxygenPlusConcentrator.type.oxygen");
    }
  })();

  const checkPathologyType = () => {
    return isArray(data?.pathology)
      ? data?.pathology?.map((ele: string) => t(`pathology.${ele}`)).join(", ")
      : data?.pathology || "-";
  };

  return (
    <div className={"template-sg oxigen-template row row-gap-4"}>
      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-7">
        <div className={"row row-gap-4"}>

          {/* Tipologia — senza validità */}
          <div className="col-sm-12 col-md-6">
            <LabelValue
              label={t("oxygenPlusConcentrator.tipologia")}
              value={tipologiaLabel}
            />
          </div>

          {/* Patologie */}
          {data?.pathology && data?.pathology.length > 0 && (
            <div className="col-sm-12 col-md-12">
              <LabelValue label={t("common.pathologies")} value={checkPathologyType()} />
              {data?.otherPathologies && (
                <LabelValue label={t("common.otherPathologies")} value={data?.otherPathologies} />
              )}
            </div>
          )}

          {/* Prescrizione ossigeno base */}
          <TemplateConcentratorPrescriptionRead
            data={data}
            title={t("sg.prescription")}
          />

          {/* Blocco portatile */}
          {selectedType === oxygenPlusConcentratorType.oxygen_portable && (
            <TemplateConcentratorPrescriptionRead
              data={data}
              prefix="portable"
              title={t("oxygenPlusConcentrator.type.oxygen_portable")}
            />
          )}

          {/* Blocco trasportabile */}
          {selectedType === oxygenPlusConcentratorType.oxygen_transportable && (
            <>
              <TemplateConcentratorPrescriptionRead
                data={data}
                prefix="transportable"
                title={t("oxygenPlusConcentrator.type.oxygen_transportable")}
              />
              <TemplateConcentratorPulsedFlowRead data={data} />
            </>
          )}
        </div>
      </div>

      {/* Altre informazioni */}
      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-5">
        <div className={"row row-gap-4"}>
          <div className="col-sm-12 col-md-12">
            <p className={"title-paragraph"}>{t("sg.otherInfo")}</p>

            <LabelValue
              label={t("prescription.template.stroller")}
              value={data?.stroller ? t("common.yes") : t("common.no")}
              className={"me-5"}
            />
            <LabelValue
              label={t("prescription.template.cannulaNasal.label")}
              value={data?.cannulaNasal ? t("common.yes") : t("common.no")}
              className={"me-5"}
            />
            {data?.cannulaNasal && (
              <>
                <LabelValue
                  label={t("prescription.template.cannulaType.label")}
                  value={data?.cannulaType || "-"}
                  className={"me-5"}
                />
                <LabelValue
                  label={t("prescription.template.cannulaModel.label")}
                  value={data?.cannulaModel || "-"}
                  className={"me-5"}
                />
              </>
            )}
          </div>

          <div className="col-sm-12 col-md-12">
            <LabelValue
              label={t("prescription.template.mask.label")}
              value={data?.mask ? t("common.yes") : t("common.no")}
              className={"me-5"}
            />
            {data?.mask && (
              <>
                <LabelValue
                  label={t("prescription.template.maskType.label")}
                  value={data?.maskType || "-"}
                  className={"me-5"}
                />
                <LabelValue
                  label={t("prescription.template.maskModel.label")}
                  value={data?.maskModel || "-"}
                  className={"me-5"}
                />
              </>
            )}
          </div>
        </div>
      </div>

      <div className={"row row-gap-4"}>
        <div className="col-sm-12 col-md-12">
          <LabelValue label={t("prescription.template.note.label")} value={data?.note || "-"} />
        </div>
      </div>

      {/* Blocco VoxiSud in fondo */}
      <VoxiSudFooterRead data={data} />
    </div>
  );
}
